<div class="w-full">
    <mat-progress-bar
        class="example-margin"
        id="tilled-progress-bar"
        [color]="colorClass"
        [mode]="mode"
        [value]="value">
    </mat-progress-bar>
</div>
